import { alert, closeAlert } from "../redux/slices/alertSlice";

export default function useAlert() {
  return { alert, closeAlert };
}
